export const removeResponsiveFontStyles = ({ typography, }) => {
    Object.keys(typography)
        .filter((key) => typeof typography[key] === "object")
        .forEach((key) => {
        const typographyObj = typography[key];
        Object.keys(typographyObj).forEach((typographyObjKey) => {
            if (typographyObjKey.startsWith("@media")) {
                delete typographyObj[typographyObjKey];
            }
        });
    });
};
//# sourceMappingURL=typography.utils.js.map